import React, { useState } from "react";
import { useTranslations, Autocomplete, useGraphqlQuery } from "@openimis/fe-core";

const DropDownSchemesPicker = (props) => {
  const {
    onChange,
    readOnly,
    required,
    withLabel = true,
    withPlaceholder,
    value,
    label,
    filterOptions,
    filterSelectedOptions,
    placeholder,
    extraFragment,
    multiple,
  } = props;
  const [searchString, setSearchString] = useState(null);
  const { formatMessage } = useTranslations("programs");

  const { isLoading, data, error } = useGraphqlQuery(
    `query SchemePicker {
      schemes {
        edges {
          node {
            id
            uuid
            code
            name
            schemeType
            amount
            status
            ${extraFragment ?? ""}
          } 
        }
      }
    }`,
    { searchString, first: 20 },
    { skip: true }
  );

  return (
    <Autocomplete
      multiple={multiple}
      required={required}
      placeholder={placeholder ?? formatMessage("SchemePicker.placeholder")}
      label={label ?? formatMessage("SchemePicker.label")}
      error={error}
      withLabel={withLabel}
      withPlaceholder={withPlaceholder}
      readOnly={readOnly}
      options={data?.schemes?.edges.map((edge) => edge.node) ?? []}
      isLoading={isLoading}
      value={value}
      getOptionLabel={(option) => `${option.code} ${option.name}`}
      onChange={(option) => onChange(option, option ? `${option.code} ${option.name}` : null)}
      filterOptions={filterOptions}
      filterSelectedOptions={filterSelectedOptions}
      onInputChange={setSearchString}
    />
  );
};

export default DropDownSchemesPicker;